import { BannerTextColor } from '@backmarket/http-api/src/api-specs-content/models/banner'

export const getBannerTextColorClass = (textColor?: BannerTextColor) =>
  textColor === BannerTextColor.White
    ? 'text-static-light-hi'
    : 'text-static-default-mid'
